// extracted by mini-css-extract-plugin
module.exports = {"container":"youYiKangManagement_container__1SSSf","tabs":"youYiKangManagement_tabs__3Ht1O"};